var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconModalAsset = function SvgIconModalAsset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v9h32V0H0Zm29.333 6.75H2.667v-4.5h26.666v4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h1v1H5zM8 5h1v1H8zM13 5h1v1h-1zM0 22h32v-9H0v9Zm2.667-6.75h26.666v4.5H2.667v-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16h1v1H5zM8 16h1v1H8zM13 16h1v1h-1zM17.333 24h-2.666v5.333H0V32h32v-2.667H17.333z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconModalAsset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_modal_asset.f360b291.svg";
export { ForwardRef as ReactComponent };